import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { GET_OFFLINE_COUPONS, GET_OFFLINE_COUPONS_SUCCESS, GET_OFFLINE_COUPONS_ERROR, USE_OFFLINE_COUPONS, USE_OFFLINE_COUPONS_ERROR } from '../constants';
import { setErrorCode } from '../redux/Actions/ErrorAction';
const apiCallHandler = invokeApi;
export function* getOfflineCouponCall() {
    try {
        const { response, status } = yield call(apiCallHandler, networkConfig.getUserOfflineCoupons, null, {}, {});
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.success) {
            yield put({
                type: GET_OFFLINE_COUPONS_SUCCESS,
                payload: response?.coupons,
            });
        }
        else {
            yield put({
                type: GET_OFFLINE_COUPONS_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_OFFLINE_COUPONS_ERROR,
        });
    }
}
export function* getOfflineCouponSaga() {
    yield takeLatest(GET_OFFLINE_COUPONS, getOfflineCouponCall);
}
export function* useOfflineCouponCall(action) {
    const couponId = action.payload?.couponId;
    try {
        const { response, status } = yield call(apiCallHandler, networkConfig.useOfflineCoupon, null, {}, { "couponCode": couponId });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response?.success) {
            yield put({
                type: GET_OFFLINE_COUPONS,
            });
        }
        else {
            yield put({
                type: USE_OFFLINE_COUPONS_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: USE_OFFLINE_COUPONS_ERROR,
        });
    }
}
export function* useOfflineCouponSaga() {
    yield takeLatest(USE_OFFLINE_COUPONS, useOfflineCouponCall);
}
